import {
  Alert,
  AlertTitle,
  Button,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import React, { FC, Fragment } from "react";
import { camelCaseToTitleCase } from "../../../utils";

interface Props {
  data: {
    label: string;
    value: any;
  }[];
  submitButtonProps?: {
    onSubmit: () => void;
    label: string;
    icon?: any;
    disabled?: boolean;
  };
  isLoading?: boolean;
}

const namesMap: any = {
  subtotal: "Subtotal",
  coupon: "Coupon Code",
  taxes: "Tax (Inclusive)",
  mrp: "Total MRP",
  sellingPrice: "Total Amount",
  discount: "Discount on MRP",
  couponDiscount: "Coupon Discount",
};

export const PriceDetailsGrid: FC<Props> = ({ data, submitButtonProps }) => {
  return (
    <div className="flex flex-col gap-6 rounded-md">
      <div className="space-y-3">
        <Typography variant="subtitle1" fontWeight={700}>
          Price Details
        </Typography>
        <Divider />
      </div>
      <div>
        <div className="grid grid-cols-2 gap-3">
          {data.map(d => (
            <Fragment key={d.label}>
              <div>
                <span className="text-sm tracking-wide font-normal">
                  {namesMap[d.label]
                    ? namesMap[d.label]
                    : camelCaseToTitleCase(d.label as string)}
                </span>
              </div>
              <div className="flex justify-end tracking-wide">
                <span className="font-bold">{d.value}</span>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
      {submitButtonProps && (
        <Stack gap={1} sx={{ position: "sticky", bottom: { lg: 0, xs: 3 } }}>
          {/* <Alert color="success" icon={"😃"}>
            <AlertTitle sx={{ fontSize: "14px" }}>
              Congratulations! You're on your way to shining brighter with{" "}
              <Typography
                variant="body2"
                component="span"
                fontWeight={700}
                color="inherit">
                JUMKEY300
              </Typography>
              . Use the code now and enjoy your sparkling purchase.
            </AlertTitle>
          </Alert>
          <Alert color="error" icon={"😞"}>
            <AlertTitle sx={{ fontSize: "14px" }}>
              Don't miss out on your chance to unlock the glittering offer!
              You're just Rs.300 away from using{" "}
              <Typography
                variant="body2"
                component="span"
                fontWeight={700}
                color="inherit">
                JUMKEY300
              </Typography>{" "}
              for a sparkling discount.
            </AlertTitle>
          </Alert> */}
          <Button
            disabled={
              submitButtonProps.disabled ? submitButtonProps.disabled : false
            }
            fullWidth
            size="large"
            variant="contained"
            onClick={submitButtonProps.onSubmit}
            endIcon={submitButtonProps.icon ? submitButtonProps.icon : null}>
            {submitButtonProps.label}
          </Button>
        </Stack>
      )}
    </div>
  );
};
